import { chakra } from '@stockx/ui';

export const SubMenuAnimationWrapper = chakra('div', {
  baseStyle: {
    position: 'absolute',
    top: 0,
    left: '100%',
    width: 0,
    opacity: 0,
    height: '100%',
    transition: 'opacity 0.3s linear, left 0.3s linear',

    '&.visible': {
      left: 0,
      width: '100%',
      opacity: 1,
    },
  },
});
